import { createAction, props } from '@ngrx/store';

export const heightExpanded = createAction(
  '[groupExpandable] heightExpanded',
  props<{ nameGroup: string; height: number }>(),
);

export const valueExpanded = createAction(
  '[groupExpandable] valueExpanded',
  props<{ nameGroup: string; value: boolean }>(),
);
